<template>
  <div class="spread flex ai-c">
    <template v-for="(item, index) in 261">
      <img v-show="place == index" :src="require('@/assets/images/spread/' + (index + 1) + '.jpg')" alt="">
    </template>
  </div>
</template>

<script>
export default {
  components: {},
  props: ['Index'],
  data() {
    return {
    }
  },
  watch: {},
  computed: {
    place() {
      return this.Index + 1
    }
  },
  methods: {},
  created() {

  },
  mounted() { }
}
</script>
<style scoped>
.spread {
  position: absolute;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  /* background-color: #e96c32; */
  overflow: hidden;
}

.spread img {
  width: 100%;
  min-height: 14.97rem;
  height: 100vh;
}
</style>